import { connect } from 'react-redux';
import { toggleFeedbackPage, toggleBurgerMenuRequested, openNotificationsDropdown, closeNotificationsDropdown } from '../../redux/actions';
import { getFeedbackCount } from '../../../publicSession/selectors';
import { getIsFeedbackPageOpen, getIsNotificationsDropdownOpen } from '../../redux/selectors';
const mapStateToProps = (state)=>({
        isFeedbackPageOpen: getIsFeedbackPageOpen(state),
        isNotificationsDropdownOpen: getIsNotificationsDropdownOpen(state),
        feedbackCount: getFeedbackCount(state)
    });
const mapDispatchToProps = {
    toggleFeedbackPage,
    toggleBurgerMenu: toggleBurgerMenuRequested,
    openNotificationsDropdown,
    closeNotificationsDropdown
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=NotificationsDropdownWrapper.container.js.map